import { render, staticRenderFns } from "./remote.vue?vue&type=template&id=51356665&scoped=true"
import script from "./remote.vue?vue&type=script&lang=js"
export * from "./remote.vue?vue&type=script&lang=js"
import style0 from "./remote.vue?vue&type=style&index=0&id=51356665&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51356665",
  null
  
)

export default component.exports